import * as Yup from 'yup'

export const passwordValidation = Yup.object().shape({
  password: Yup.string()
    .min(5)
    .max(50)
    .required('Password Required')
})
